import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {ChooseDoctorListModalComponent} from "./choose-doctor-list-modal.component";

const routes: Routes = [
  {
    path: '',
    component: ChooseDoctorListModalComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChooseDoctorListModalRoutingModule {}
